import { z } from 'zod'
import { t } from 'i18next'
import {
  KmSchema,
  ZugmeldestelleNameSchema
} from '../../Generic/schema/generic.schema'
import { Betriebsstellenart } from '../../../../types'

// Default constants
export const DEFAULT_AUFTRAG_25_10 = {
  enabled: false,
  km: '',
  selector: '' as const,
  name: ''
}

export const DEFAULT_AUFTRAG_25_20 = {
  enabled: false,
  km: '',
  selector: '' as const,
  name: ''
}

export const DEFAULT_AUFTRAG_25_30 = {
  enabled: false,
  km: '',
  selector: '' as const,
  name: ''
}

export const DEFAULT_AUFTRAG_25_34 = {
  enabled: false
}

const DEFAULT_BEFEHL_25_FORM = {
  auftrag_25_10: DEFAULT_AUFTRAG_25_10,
  auftrag_25_20: DEFAULT_AUFTRAG_25_20,
  auftrag_25_30: DEFAULT_AUFTRAG_25_30,
  auftrag_25_34: DEFAULT_AUFTRAG_25_34
}

// Schema definitions
export const Auftrag25_10Schema = z
  .object({
    enabled: z.boolean().default(DEFAULT_AUFTRAG_25_10.enabled),
    km: KmSchema,
    selector: z
      .enum(['', Betriebsstellenart.Abzw, Betriebsstellenart.Uest])
      .default(DEFAULT_AUFTRAG_25_10.selector),
    name: ZugmeldestelleNameSchema
  })
  .default(() => structuredClone(DEFAULT_AUFTRAG_25_10))

export const Auftrag25_20Schema = z
  .object({
    enabled: z.boolean().default(DEFAULT_AUFTRAG_25_20.enabled),
    km: KmSchema,
    selector: z
      .enum(['', Betriebsstellenart.Abzw, Betriebsstellenart.Uest])
      .default(DEFAULT_AUFTRAG_25_20.selector),
    name: ZugmeldestelleNameSchema
  })
  .default(() => structuredClone(DEFAULT_AUFTRAG_25_20))

export const Auftrag25_30Schema = z
  .object({
    enabled: z.boolean().default(DEFAULT_AUFTRAG_25_30.enabled),
    km: KmSchema,
    selector: z
      .enum(['', Betriebsstellenart.Bf, Betriebsstellenart.Bft])
      .default(DEFAULT_AUFTRAG_25_30.selector),
    name: ZugmeldestelleNameSchema
  })
  .default(() => structuredClone(DEFAULT_AUFTRAG_25_30))

const Auftrag25_34Schema = z
  .object({
    enabled: z.boolean().default(DEFAULT_AUFTRAG_25_34.enabled)
  })
  .default(() => structuredClone(DEFAULT_AUFTRAG_25_34))

// Base schema
const Befehl25FormSchemaBase = z
  .object({
    auftrag_25_10: Auftrag25_10Schema,
    auftrag_25_20: Auftrag25_20Schema,
    auftrag_25_30: Auftrag25_30Schema,
    auftrag_25_34: Auftrag25_34Schema
  })
  .default(() => structuredClone(DEFAULT_BEFEHL_25_FORM))

export const Befehl25FormSchema = Befehl25FormSchemaBase

// Validation schema
export const createBefehl25FormValidationSchema = () =>
  Befehl25FormSchema.refine(
    (data) => {
      return data.auftrag_25_10.enabled || data.auftrag_25_30.enabled
    },
    {
      message: t('ui-validation:befehl25.at_least_one')
    }
  )

export type Befehl25FormData = z.infer<typeof Befehl25FormSchemaBase>
